import { render, staticRenderFns } from "./news_header.vue?vue&type=template&id=79fc12bc&scoped=true&"
import script from "./news_header.vue?vue&type=script&lang=js&"
export * from "./news_header.vue?vue&type=script&lang=js&"
import style0 from "./news_header.vue?vue&type=style&index=0&id=79fc12bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc12bc",
  null
  
)

export default component.exports